'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactResponsiveModal = require('react-responsive-modal');

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockingModal = function blockingModal(content) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'status';
  return _react2.default.createElement(
    _reactResponsiveModal2.default,
    {
      open: true,
      center: true,
      closeOnOverlayClick: false,
      showCloseIcon: false,
      onClose: function onClose() {
        return null;
      },
      classNames: { overlay: 'loading-overlay', modal: 'modal-wrapper ' + type }
    },
    content
  );
};

exports.default = blockingModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/blockingModal.js
// module id = 1137
// module chunks = 0